import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {BackendAction} from "@dropDesk/domain/entities/common/actions_entity";

export class InternalChatUserEntity {
    idCompany!: string;
    idInternalChat!: string;
    idUser!: string;
    user?: UserEntity;
    internalChat?: InternalChatEntity;
    action?: BackendAction;

    constructor(data?: Partial<InternalChatUserEntity>) {
        Object.assign(this, data);
    }

    public static fromJson(json: Record<string, any>): InternalChatUserEntity {
        return new InternalChatUserEntity({
            idCompany: json['idCompany'],
            idInternalChat: json['idInternalChat'],
            idUser: json['idUser'],
            user: json['user'] ? UserEntity.fromJson(json['user']) : undefined,
            internalChat: json['internalChat'] ? InternalChatEntity.fromJson(json['internalChat']) : undefined,
            action: json['action'],
        });
    }

    public removeCalculatedVariables(): InternalChatUserEntity {
        const newObject = this.copyWith(this);
        delete newObject.internalChat;
        delete newObject.user;
        return newObject;
    }

    copyWith({
                 idCompany,
                 idInternalChat,
                 idUser,
                 user,
                 internalChat,
                 action,
                 replaceActionIfNull
             }: {
        idCompany?: string;
        idInternalChat?: string;
        idUser?: string;
        user?: UserEntity | null;
        internalChat?: InternalChatEntity;
        action?: BackendAction;
        replaceActionIfNull?: boolean | null;

    }): InternalChatUserEntity {
        return new InternalChatUserEntity({
            idCompany: idCompany ?? this.idCompany,
            idInternalChat: idInternalChat ?? this.idInternalChat,
            idUser: idUser ?? this.idUser,
            user: user ?? this.user,
            internalChat: internalChat ?? this.internalChat,
            action: replaceActionIfNull ? action : this.action,
        })
    }
}
